import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetQuotations } from "api/queries/quotes/useGetQuotations";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import Button from "components/v2/Button/Button";
import getLabel, { getLabelWithTranslationFallback } from "helpers/getLabel";
import { HandleClickRequestApprovalParams } from "../hooks/useApprovalFlowDialogs";

interface QuotationFooterMainActionsProps {
  showManageApprovalButton: boolean;
  showBookButton: boolean;
  showRequestApprovalButton: boolean;
  handleClickRequestApproval: (params: HandleClickRequestApprovalParams) => void;
  handleClickManageApproval: () => void;
  handleClickBook: () => void;
}

export default function QuotationFooterMainActions({
  showManageApprovalButton,
  showBookButton,
  showRequestApprovalButton,
  handleClickRequestApproval,
  handleClickManageApproval,
  handleClickBook,
}: QuotationFooterMainActionsProps) {
  const intl = useIntl();
  const { id } = useParams();

  const { data: shipmentData } = useGetShipmentBasic(id!, {
    enabled: !!id,
  });
  const { data: quotationsData } = useGetQuotations({
    shipmentId: id!,
    options: {
      enabled: !!id,
    },
  });

  const quotationSettings = quotationsData?.settings;

  const bookLabel =
    getLabel("Book", "capitalize-first", shipmentData?.organization?.payment_location_reference, true) ??
    quotationSettings?.book_label;

  return (
    <>
      {showManageApprovalButton && (
        <Button
          label={intl.formatMessage({
            id: "shipment-quotes.components.quotes.manageApproval",
            defaultMessage: "Manage Approval",
          })}
          onClick={handleClickManageApproval}
        />
      )}

      {showBookButton && <Button label={bookLabel} onClick={handleClickBook} />}

      {showRequestApprovalButton && quotationSettings?.quotes_threshold_exceeded && (
        <Button
          label={
            getLabelWithTranslationFallback("Request approval", {
              translation: (
                <FormattedMessage id="shipment-quotes.components.quotes.requestApproval" defaultMessage="Request approval" />
              ),
              style: "capitalize-first",
              paymentLocation: shipmentData?.organization?.payment_location_reference,
              returnAsString: true,
            }) ?? quotationSettings?.request_approve_label
          }
          onClick={() => handleClickRequestApproval({})}
        />
      )}
    </>
  );
}
